<template>
  <div>
    <v-col>
      <h1 class="container3 mt-16">
        {{ message }}
      </h1>
      <div class="container3 mt-10">
        <img
          src="./../../../../../assets/no_routes.png"
          height="400px"
          width="400px"
        >
      </div>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "EmptyVoyages",
  props: {
    message: String,
  },
};
</script>

    <style scoped>
.container3 {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
